import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'ca-rename-confirmation-dialog',
    templateUrl: './rename-confirmation-dialog.component.html',
    styleUrls: ['./rename-confirmation-dialog.component.scss'],
})
export class RenameConfirmationDialogComponent implements OnInit {
    @Input() title: string;
    @Input() inputLabel: string;
    @Input() oldName: string;
    formGroup: UntypedFormGroup;
    constructor(
        private activeModal: NgbActiveModal,
        private formBuilder: UntypedFormBuilder,
    ) {}

    close(): void {
        this.activeModal.close();
    }

    dismiss(): void {
        this.activeModal.dismiss('canceled');
    }

    submit(): void {
        this.activeModal.close(this.formGroup.value.name.trim());
    }

    ngOnInit(): void {
        this.formGroup = this.formBuilder.group({
            name: [this.oldName, [Validators.required]],
        });
    }
}
